import { useKycVerificationContext } from "../../Contexts/KycVerificationContext";
import NumberField from "../../Components/NumberField";
import { PaymentOutlined } from "@mui/icons-material";
import InputField from "../../Components/InputField";
import DatePicker from "../../Components/DatePicker";
import UploadSignature from "./UploadSignature";
import UploadModal from "./UploadModal";
import Camera from "./Camera";
import dayjs from "dayjs";
import {
  FormControlLabel,
  FormControl,
  RadioGroup,
  FormGroup,
  Checkbox,
  Radio,
  Stack,
} from "@mui/material";

function PersonalInfo() {
  const {
    setShowUploadModal,
    setHasUploadError,
    setIsTncAccepted,
    setErrorMessage,
    showUploadModal,
    setIsCameraOpen,
    isTncAccepted,
    errorMessage,
    isCameraOpen,
    setFormData,
    formData,
  } = useKycVerificationContext();

  const handleUploadSuccess = (file) => {
    if (file) {
      let newForm = {
        ...formData,
        signature: file,
      };
      setFormData(newForm);
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "cardNumber") {
      const input = e.target;
      const inputValue = input.value.replace(/\s/g, "");
      const numericValue = inputValue.replace(/\D/g, "");
      const selectionStart = input.selectionStart;
      const isDeleting = e.nativeEvent.inputType === "deleteContentBackward";

      if (/^\d*$/.test(inputValue) && numericValue.length <= 16) {
        const numberWithSpaces = numericValue.replace(/(\d{4})/g, "$1 ").trim();
        setFormData({ ...formData, [e.target.name]: numberWithSpaces });

        let newCaretPosition = selectionStart;

        if (
          isDeleting &&
          selectionStart > 0 &&
          numberWithSpaces[selectionStart - 1] === " "
        ) {
          newCaretPosition--;
        }

        if (
          !isDeleting &&
          selectionStart > 0 &&
          numberWithSpaces[selectionStart - 1] === " "
        ) {
          newCaretPosition++;
        }

        setTimeout(() => {
          input.setSelectionRange(newCaretPosition, newCaretPosition);
        });
      }
    } else {
      let newForm = {
        ...formData,
        [e.target.name]: e.target.value,
      };
      setFormData(newForm);
      setErrorMessage("");
    }
  };

  const handleDateChange = (name, date) => {
    let newForm = {
      ...formData,
      [name]: dayjs(date).format("MM/DD/YYYY"),
    };
    setFormData(newForm);
    setErrorMessage("");
  };

  const handleViewTerms = () => {};

  const handleViewPolicy = () => {};

  const handleOpenCamera = () => {
    setIsCameraOpen(true);
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
  };

  const handleCloseUpload = () => {
    setShowUploadModal(false);
  };

  const handleCaptureComplete = (file) => {
    if (file.size > 1000000) {
      setHasUploadError(true);
    } else {
      setHasUploadError(false);
    }
    let newForm = {
      ...formData,
      signature: file,
    };
    setFormData(newForm);
    setShowUploadModal(false);
  };

  const onAcceptTnc = (e) => {
    setIsTncAccepted(e.target.checked);
  };

  let errMsg = errorMessage && (
    <p className="font-bold text-red-600 mb-2">{errorMessage}</p>
  );

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-4">
        Personal Information
      </p>
      {errMsg}
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Maxicare Card Number</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="cardNumber"
            placeholder="1168 0000 0000 0000"
            adornment={<PaymentOutlined sx={{ color: "#A3A7AB" }} />}
            value={formData.cardNumber}
            onChange={handleChange}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">First name</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Middle name</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="middleName"
            value={formData.middleName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Last name</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Suffix</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="suffix"
            value={formData.suffix}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Gender</p>
        <div className="mt-1">
          <RadioGroup
            row
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="Male"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
          >
            <FormControlLabel
              value="Male"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="Male"
            />
            <FormControlLabel
              value="Female"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": {
                      fontSize: 18,
                    },
                  }}
                />
              }
              label="Female"
            />
          </RadioGroup>
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Date of birth</p>
        <div className="mt-1">
          <DatePicker
            name="dateOfBirth"
            value={
              formData.dateOfBirth !== "" ? dayjs(formData.dateOfBirth) : null
            }
            onAccept={(value) => handleDateChange("dateOfBirth", value)}
            maxDate={dayjs().subtract(18, "years")}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Valid ID number</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="idNumber"
            value={formData.idNumber}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Mobile number</p>
        <div className="mt-1">
          <NumberField
            name="mobileNumber"
            value={formData.mobileNumber}
            adornment="+63"
            maxLength={10}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Email address</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="emailAddress"
            value={formData.emailAddress}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Nationality</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="nationality"
            value={formData.nationality}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Place of birth</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="placeOfBirth"
            value={formData.placeOfBirth}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Address</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="bldgName"
            value={formData.bldgName}
            placeholder="Unit/Flr/Bldg name"
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
        <div className="mt-3">
          <InputField
            type="text"
            name="street"
            value={formData.street}
            placeholder="Street No./Name"
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
        <div className="mt-3">
          <InputField
            type="text"
            name="subdivision"
            value={formData.subdivision}
            placeholder="Subdivision/Village"
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
        <Stack direction="row" spacing={2} className="mt-3">
          <div className="w-full">
            <InputField
              type="text"
              name="city"
              value={formData.city}
              placeholder="City"
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
              }}
            />
          </div>
          <div className="w-full">
            <InputField
              type="text"
              name="state"
              value={formData.state}
              placeholder="State"
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
              }}
            />
          </div>
        </Stack>
        <Stack direction="row" spacing={2} className="mt-3">
          <div className="w-full">
            <InputField
              type="text"
              name="areaCode"
              value={formData.areaCode}
              placeholder="Area code"
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
              }}
            />
          </div>
          <div className="w-full">
            <InputField
              type="text"
              name="zipCode"
              value={formData.zipCode}
              placeholder="Zip code"
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
              }}
            />
          </div>
        </Stack>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Mother's maiden name</p>
        <div className="mt-1">
          <InputField
            type="text"
            placeholder="First Name"
            name="mothersFirstName"
            value={formData.mothersFirstName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
        <div className="mt-3">
          <InputField
            type="text"
            placeholder="Middle Name"
            name="mothersMiddleName"
            value={formData.mothersMiddleName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
        <div className="mt-3">
          <InputField
            type="text"
            placeholder="Last Name"
            name="mothersLastName"
            value={formData.mothersLastName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Company name / Employer name</p>
        <div className="mt-1">
          <InputField
            type="text"
            name="companyName"
            value={formData.companyName}
            onChange={handleChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^\x20-\x7EñÑ]+/g, "");
            }}
          />
        </div>
      </FormControl>
      <FormControl sx={{ width: "100%", mb: 2 }}>
        <p className="font-semibold">Signature</p>
        <div className="mt-1">
          <UploadSignature />
        </div>
      </FormControl>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={isTncAccepted} onChange={onAcceptTnc} />}
          label={
            <p className="text-sm">
              I hereby consent to abide by the{" "}
              <button onClick={handleViewTerms} className="text-[#0869cf]">
                Terms & Conditions
              </button>{" "}
              as well as the{" "}
              <button onClick={handleViewPolicy} className="text-[#0869cf]">
                Privacy Policy
              </button>
            </p>
          }
        />
      </FormGroup>
      <UploadModal
        open={showUploadModal}
        setHasUploadError={setHasUploadError}
        onUploadSuccess={handleUploadSuccess}
        onOpenCamera={handleOpenCamera}
        onClose={handleCloseUpload}
      />
      <Camera
        open={isCameraOpen}
        onClose={handleCloseCamera}
        onComplete={handleCaptureComplete}
      />
    </div>
  );
}

export default PersonalInfo;
